export default __webpack_public_path__ + "static/logo-c7dc765118a1fdeac942a874fd06cbc8.png";